import React from 'react';
import InputGroup from 'ub/ui/inline-text/input-group';
import FontSize from 'ub/components/properties-panel/font-size';
import FontPickerFontFamily from
  'ub/ui/inline-text/style-tab-content-components/font-picker-font-family.jsx';

import buttonStateController from 'ub/fonts/font-picker/button/state-controller.js';
import initialState from 'ub/fonts/font-picker/button/initial-state';
import FontStyleButtonGroup from 'ub/components/properties-panel/font-style-button-group';

class ButtonFontPicker extends React.Component {
  constructor() {
    super();

    this.state = initialState;

    this.changeHandler = this.changeHandler.bind(this);

    buttonStateController
      .fontActionsSubject
      .onNext({type: 'renderInitialState'});

    this.stateSubscription = buttonStateController
      .stateChangedSubject
      .subscribe((newState) => {
        this.setState(newState);
      });
  }

  changeHandler(eventData) {
    buttonStateController.fontActionsSubject.onNext(eventData);
  }

  componentWillUnmount() {
    this.stateSubscription.dispose();
  }

  render() {
    return (
      <div>
        <div className='row-input-group family-size-input-group'>
          <InputGroup title='Family' newTag>
            <FontPickerFontFamily
              changeHandler={this.changeHandler}
              selectedFontFamily={this.state.family}
              selectedWeight={this.state.weight}
              selectedFontStyle={this.state.style}
              wide
            />
          </InputGroup>

          <InputGroup title='Size (px)'>
            <FontSize
              changeHandler={this.changeHandler}
              fontSize={this.state.size}
            />
          </InputGroup>
        </div>

        <div className='row-input-group family-size-input-group'>
          <InputGroup title='Style'>
            <div className='input-items font-style-btn-group'>
              <FontStyleButtonGroup
                changeHandler={this.changeHandler}
                textStyles={this.state.textStyles}
                allowedStyles={['bold', 'italic']}
              />
            </div>
          </InputGroup>
        </div>
      </div>
    );
  }
}

export default ButtonFontPicker;



// WEBPACK FOOTER //
// ./src/fonts/font-picker/button/font-picker.jsx